import React from "react";

export default function PromoCodeAlert({ promoCodeMessage, onDismiss }) {
   // Only show warning alert when there's an error message
   if (!promoCodeMessage) {
      return null;
   }

   return (
      <div className="alert alert-warning alert-dismissible fade show mb-4" role="alert">
         <span>{promoCodeMessage}</span>
         <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onDismiss}
         />
      </div>
   );
}
